export const getWorkspacesEndPoint = 'workspace-users/all-workspaces';
export const workspaceEndPoint = 'workspaces';
